import React from "react";
import { Link } from "react-router-dom";
import { dishes } from "../data/dishes";
import { photos } from "../data/photos";
import { useTheme, useDocumentTitle } from "../hooks/useSite";
import Carousel from "../components/Carousel";
import { Guest, Panorama } from "../illustrations";

const slides = [
  { src: photos.rollsClose, alt: "Choco chip cookie dough ice cream rolls", title: "A little sweet.", text: "Hand-rolled ice cream on the cold plate, the dessert RollOver started with." },
  { src: photos.burger, alt: "Veg cheese burger", title: "A generous bite.", text: "Burgers, sandwiches, momos and munchies for the savoury side of the mood." },
  { src: photos.store1, alt: "Guests at the RollOver counter during an event", title: "A table together.", text: "Food is only part of it. There is also the conversation, the celebration and the time you make for each other." },
  { src: photos.signage, alt: "RollOver sign inside the café", title: "A local good mood.", text: "Warmth, taste and playful energy, in Hanamkonda, Warangal." },
];

export default function StoryPage() {
  useTheme(dishes[0]);
  useDocumentTitle("Our Story");
  return (
    <>
      <section className="ro-story-cover" style={{ backgroundImage: `url("${photos.party}")` }}>
        <h1>
          The Story of <span className="ro-outline ro-outline--light">RollOver</span>
        </h1>
        <span className="ro-micro ro-story-cover__note">RollOver café photography</span>
      </section>
      <div className="ro-editorial-body">
        <section className="ro-section ro-tinted">
          <div className="ro-container">
            <h2>
              Good food. <span className="ro-outline">Good mood.</span> Great times.
            </h2>
            <p>
              RollOver is passionate about bringing the delicious, affordable flavours of Thai-style ice cream rolls and creative fast food to Warangal. The menu pairs hand-crafted ice cream rolls with fresh, vibrant fusion dishes, all made to satisfy a craving and share a good moment.
            </p>
          </div>
        </section>
        <section className="ro-story-slider">
          <div className="ro-container">
            <h2 style={{ marginBottom: 40 }}>
              Four ways to <span className="ro-outline">RollOver.</span>
            </h2>
            <Carousel
              slides={slides}
              label="Café moments"
              className="ro-carousel--story"
              renderSlide={(s) => (
                <div className="ro-story-slide">
                  <img src={s.src} alt={s.alt} />
                  <div>
                    <h3>{s.title}</h3>
                    <p>{s.text}</p>
                  </div>
                </div>
              )}
            />
          </div>
        </section>
        <section className="ro-section">
          <div className="ro-container ro-split">
            <div className="ro-education-illustration">
              <Guest />
            </div>
            <div>
              <h2>
                A little joy in <span className="ro-outline">every break.</span>
              </h2>
              <p>
                Drop in for an idea, browse for a craving, or find something to share. Birthdays, farewells and get-togethers happen here too, in-store or outdoors, and the team is happy to help plan them.
              </p>
              <Link to="/events" className="ro-pill" style={{ marginTop: 30 }}>
                See celebrations
              </Link>
            </div>
          </div>
        </section>
        <section className="ro-section ro-tinted">
          <div className="ro-container ro-container--narrow">
            <h2>
              A fun, affordable <span className="ro-outline">hangout spot.</span>
            </h2>
            <p>
              Looking for a fun and affordable hangout spot? Look no further than RollOver Warangal. Our cosy and inviting space is the perfect place to relax, unwind and enjoy some delicious food and drinks. We offer a selection of board games and other entertainment, so you can challenge your friends and family to a friendly competition or just enjoy some quality time together.
            </p>
            <p>
              When you need a break from the games, indulge in our signature ice cream rolls or try one of our fast food dishes: momos, sandwiches, burgers, fries, shakes and more.
            </p>
          </div>
        </section>
        <section className="ro-section">
          <div className="ro-container ro-container--narrow">
            <h2>
              Food <span className="ro-outline">memory.</span>
            </h2>
            <p>
              Food and memory are closely related. The smell of a certain dish can bring back a happy childhood moment, and that feeling is exactly what a good café break is for. That is why RollOver cares as much about the table and the company as about what is on the plate.
            </p>
          </div>
        </section>
        <section className="ro-section ro-tinted">
          <div className="ro-container ro-container--narrow">
            <h2>
              Mana cravings… <span className="ro-outline">Mana RollOver!</span>
            </h2>
            <p>
              Warm, playful and welcoming. A little local flavour, an appetising menu and a clear way to take the next step. That is the voice carried across this café.
            </p>
            <Link to="/menu" className="ro-pill" style={{ marginTop: 35 }}>
              Find your craving
            </Link>
          </div>
        </section>
      </div>
      <Panorama className="ro-panorama ro-panorama--story" />
    </>
  );
}
